export default __webpack_public_path__ + "maps-examples-constraining-gestures-thumbnail-480-40e333ca130e8060729404e82ee6ae53.webp";